import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent, Suspense as _Suspense, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-0" }
const _hoisted_2 = { class: "grid mb-4" }
const _hoisted_3 = { class: "col-12 lg:col-4" }
const _hoisted_4 = {
  key: 0,
  class: "card"
}
const _hoisted_5 = { class: "p-fluid" }
const _hoisted_6 = {
  key: 1,
  class: "card"
}
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "p-fluid" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = { class: "mr-2 text-sm text-indigo-300" }
const _hoisted_16 = { class: "mr-2 text-sm text-indigo-300" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "p-fluid" }
const _hoisted_19 = { class: "col-12 lg:col-4" }
const _hoisted_20 = { class: "card" }
const _hoisted_21 = { class: "p-fluid" }
const _hoisted_22 = { class: "card" }
const _hoisted_23 = { class: "p-fluid" }
const _hoisted_24 = {
  key: 0,
  class: "card"
}
const _hoisted_25 = { class: "p-fluid" }
const _hoisted_26 = { class: "card" }
const _hoisted_27 = { class: "p-fluid" }
const _hoisted_28 = { class: "card" }
const _hoisted_29 = { class: "p-fluid" }
const _hoisted_30 = { class: "p-fluid" }
const _hoisted_31 = { class: "p-fluid" }
const _hoisted_32 = { class: "col-12 lg:col-4" }
const _hoisted_33 = { class: "card" }
const _hoisted_34 = { class: "p-fluid" }
const _hoisted_35 = {
  key: 0,
  class: "card"
}
const _hoisted_36 = { class: "p-fluid" }
const _hoisted_37 = { class: "card" }
const _hoisted_38 = { class: "card" }
const _hoisted_39 = { class: "mb-3" }
const _hoisted_40 = { class: "mr-1 text-xs api-token" }
const _hoisted_41 = { class: "card" }
const _hoisted_42 = { class: "p-fluid" }
const _hoisted_43 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_44 = {
  key: 1,
  class: "card"
}
const _hoisted_45 = { class: "p-fluid" }
const _hoisted_46 = { class: "mt-0" }
const _hoisted_47 = { class: "grid mb-4" }
const _hoisted_48 = { class: "col-12 lg:col-4" }
const _hoisted_49 = { class: "card" }
const _hoisted_50 = { class: "p-fluid" }
const _hoisted_51 = { class: "col-12 lg:col-4" }
const _hoisted_52 = { class: "card" }
const _hoisted_53 = { class: "p-fluid" }
const _hoisted_54 = { class: "col-12 lg:col-4" }
const _hoisted_55 = { class: "card" }
const _hoisted_56 = { class: "p-fluid" }
const _hoisted_57 = { class: "col-12 lg:col-4" }
const _hoisted_58 = { class: "card p-fluid" }
const _hoisted_59 = { class: "col-12 lg:col-4" }
const _hoisted_60 = { class: "card p-fluid" }
const _hoisted_61 = { class: "col-12 lg:col-4" }
const _hoisted_62 = { class: "card" }
const _hoisted_63 = { class: "p-fluid" }
const _hoisted_64 = {
  key: 0,
  class: "grid mb-3"
}
const _hoisted_65 = { class: "col-12 lg:col-4" }
const _hoisted_66 = { class: "card" }
const _hoisted_67 = { class: "p-fluid" }
const _hoisted_68 = { class: "grid mb-4" }
const _hoisted_69 = { class: "col-12 lg:col-4" }
const _hoisted_70 = { class: "card" }
const _hoisted_71 = { class: "p-fluid" }
const _hoisted_72 = { class: "grid" }
const _hoisted_73 = { class: "col-12 lg:col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_FieldDropdown = _resolveComponent("FieldDropdown")!
  const _component_FieldCheckbox = _resolveComponent("FieldCheckbox")!
  const _component_FieldVertical = _resolveComponent("FieldVertical")!
  const _component_FieldTextarea = _resolveComponent("FieldTextarea")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldListBox = _resolveComponent("FieldListBox")!
  const _component_FieldNumber = _resolveComponent("FieldNumber")!
  const _component_FieldBidCPM = _resolveComponent("FieldBidCPM")!
  const _component_FieldDate = _resolveComponent("FieldDate")!
  const _component_IconPark = _resolveComponent("IconPark")!
  const _component_TargetingByValues = _resolveComponent("TargetingByValues")!
  const _component_AdSecure = _resolveComponent("AdSecure")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_Entry = _resolveComponent("Entry")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Entry, {
    "entry-errors-map": _ctx.feedErrorsMap,
    "onUpdate:entryErrorsMap": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.feedErrorsMap) = $event)),
    title: _ctx.$t('feed'),
    entry: _ctx.feed,
    "entry-fetch-handler": _ctx.fetchFeed,
    "entry-store-handler": _ctx.storeFeed
  }, {
    "buttons-col-2-prepend": _withCtx(() => [
      _createVNode(_component_PrimeVueButton, {
        class: "p-button-secondary ml-4 mb-0",
        label: _ctx.$t('clone'),
        icon: "pi pi-copy",
        onClick: _ctx.cloneFeed
      }, null, 8, ["label", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("h3", _hoisted_1, "⚙️ " + _toDisplayString(_ctx.$t('common_settings')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.feed.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_FieldText, {
                    "model-value": _ctx.feed.id,
                    label: "ID",
                    disabled: ""
                  }, null, 8, ["model-value"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isSuperAdmin())
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_FieldDropdown, {
                    modelValue: _ctx.feed.project_id,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.feed.project_id) = $event)),
                      _ctx.onProjectChange
                    ],
                    modelModifiers: { number: true },
                    name: "project_id",
                    "errors-map": _ctx.feedErrorsMap,
                    label: _ctx.$t('project'),
                    loading: _ctx.projectsLoading,
                    disabled: !!_ctx.feed.id,
                    options: _ctx.projects.data,
                    "option-value": "id",
                    "option-label": "name",
                    "option-label-translate": false
                  }, null, 8, ["modelValue", "errors-map", "label", "loading", "disabled", "options", "onUpdate:modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_FieldText, {
                modelValue: _ctx.feed.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.feed.name) = $event)),
                modelModifiers: { trim: true },
                name: "name",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('name')
              }, null, 8, ["modelValue", "errors-map", "label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.feed.traffic_type,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.feed.traffic_type) = $event)),
                  _ctx.onTrafficTypeChange
                ],
                modelModifiers: { number: true },
                name: "traffic_type",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('type'),
                disabled: !!_ctx.feed.id,
                options: _ctx.TRAFFIC_TYPES
              }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options", "onUpdate:modelValue"]),
              _createVNode(_component_FieldCheckbox, {
                modelValue: _ctx.feed.mix_traffic_type,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.feed.mix_traffic_type) = $event)),
                label: _ctx.$t('mix_traffic_type')
              }, null, 8, ["modelValue", "label"]),
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.feed.traffic_category,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.feed.traffic_category) = $event)),
                  _ctx.onTrafficCategoryChange
                ],
                modelModifiers: { number: true },
                name: "traffic_category",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('category'),
                options: _ctx.TRAFFIC_CATEGORIES
              }, null, 8, ["modelValue", "errors-map", "label", "options", "onUpdate:modelValue"]),
              _createVNode(_component_FieldVertical, {
                modelValue: _ctx.feed.vertical_id,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.feed.vertical_id) = $event)),
                modelModifiers: { number: true },
                name: "vertical_id",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('vertical'),
                help: "Apply this vertical to every ad of the feed instead of detecting it from the creative text"
              }, null, 8, ["modelValue", "errors-map", "label"]),
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.feed.region,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.feed.region) = $event)),
                modelModifiers: { number: true },
                name: "region",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('region'),
                options: _ctx.REGIONS
              }, null, 8, ["modelValue", "errors-map", "label", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_FieldTextarea, {
                modelValue: _ctx.feed.url,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.feed.url) = $event)),
                modelModifiers: { trim: true },
                name: "url",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('url')
              }, null, 8, ["modelValue", "errors-map", "label"]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('available_macros')) + ":", 1),
                _createElementVNode("div", null, [
                  _cache[63] || (_cache[63] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{endpoint_id}", -1)),
                  _cache[64] || (_cache[64] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{endpoint_uuid}", -1)),
                  _withDirectives((_openBlock(), _createElementBlock("code", _hoisted_15, [...(_cache[57] || (_cache[57] = [
                    _createTextVNode("{subid_uuid}", -1)
                  ]))])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('macros_subid_uuid_help'),
                      void 0,
                      { top: true }
                    ]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("code", _hoisted_16, [...(_cache[58] || (_cache[58] = [
                    _createTextVNode("{subid_id}", -1)
                  ]))])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('macros_subid_id_help'),
                      void 0,
                      { top: true }
                    ]
                  ]),
                  _cache[65] || (_cache[65] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{ip}", -1)),
                  _cache[66] || (_cache[66] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{country_alpha2_code}", -1)),
                  _cache[67] || (_cache[67] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{country_alpha3_code}", -1)),
                  _cache[68] || (_cache[68] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{user_agent}", -1)),
                  _cache[69] || (_cache[69] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{referrer}", -1)),
                  _cache[70] || (_cache[70] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{platform_name}", -1)),
                  _cache[71] || (_cache[71] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{platform_version_name}", -1)),
                  _cache[72] || (_cache[72] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{browser_name}", -1)),
                  _cache[73] || (_cache[73] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{browser_version_name}", -1)),
                  _cache[74] || (_cache[74] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{sec_ch_ua}", -1)),
                  _cache[75] || (_cache[75] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{sec_ch_ua_model}", -1)),
                  _cache[76] || (_cache[76] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{sec_ch_ua_mobile}", -1)),
                  _cache[77] || (_cache[77] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{sec_ch_ua_platform}", -1)),
                  _cache[78] || (_cache[78] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{sec_ch_ua_platform_version}", -1)),
                  _cache[79] || (_cache[79] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{language}", -1)),
                  _cache[80] || (_cache[80] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{timeout}", -1)),
                  _cache[81] || (_cache[81] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{request_uuid}", -1)),
                  _cache[82] || (_cache[82] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{visitor_uuid}", -1)),
                  _cache[83] || (_cache[83] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{keyword}", -1)),
                  _cache[84] || (_cache[84] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{keywords}", -1)),
                  (!_ctx.isPop)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[59] || (_cache[59] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{subscriber_uuid}", -1)),
                        _cache[60] || (_cache[60] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{subscriber_age_date}", -1)),
                        _cache[61] || (_cache[61] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{subscriber_age_timestamp}", -1)),
                        _cache[62] || (_cache[62] = _createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{subscriber_age_days}", -1))
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.feed.protocol,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.feed.protocol) = $event)),
                modelModifiers: { number: true },
                name: "protocol",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('protocol'),
                disabled: _ctx.isVideo,
                options: _ctx.PROTOCOLS
              }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options"]),
              (_ctx.feed.protocol === _ctx.PROTOCOL_LEGACY)
                ? (_openBlock(), _createBlock(_component_FieldDropdown, {
                    key: 0,
                    modelValue: _ctx.feed.scheme_id,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.feed.scheme_id) = $event)),
                    modelModifiers: { number: true },
                    name: "scheme_id",
                    "errors-map": _ctx.feedErrorsMap,
                    label: _ctx.$t('scheme'),
                    loading: _ctx.schemesLoading,
                    options: _ctx.schemes.data,
                    "option-value": "id",
                    "option-label": "compiled_name",
                    "option-label-translate": false,
                    filter: true
                  }, null, 8, ["modelValue", "errors-map", "label", "loading", "options"]))
                : _createCommentVNode("", true),
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.feed.customizer,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.feed.customizer) = $event)),
                modelModifiers: { number: true },
                name: "customizer",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('customizer'),
                options: _ctx.FEED_CUSTOMIZERS,
                "show-clear": ""
              }, null, 8, ["modelValue", "errors-map", "label", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.feed.redirect_type,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.feed.redirect_type) = $event)),
                modelModifiers: { number: true },
                name: "redirect_type",
                "errors-map": _ctx.feedErrorsMap,
                label: "Redirect type",
                options: _ctx.REDIRECT_TYPES
              }, null, 8, ["modelValue", "errors-map", "options"]),
              _createVNode(_component_FieldCheckbox, {
                modelValue: _ctx.feed.referrer_spoofing,
                "onUpdate:modelValue": [
                  _cache[12] || (_cache[12] = ($event: any) => ((_ctx.feed.referrer_spoofing) = $event)),
                  _ctx.onReferrerSpoofingChange
                ],
                label: _ctx.$t('referrer_spoofing')
              }, null, 8, ["modelValue", "label", "onUpdate:modelValue"]),
              (_ctx.feed.referrer_spoofing)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_FieldDropdown, {
                      modelValue: _ctx.feed.targeting_by_pseudosites,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.feed.targeting_by_pseudosites) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_pseudosites",
                      label: _ctx.$t('targeting_by_pseudosites'),
                      options: _ctx.TARGETING_TYPES_BY_PSEUDOSITES
                    }, null, 8, ["modelValue", "label", "options"]),
                    (_ctx.feed.targeting_by_pseudosites !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createBlock(_component_FieldListBox, {
                          key: 0,
                          modelValue: _ctx.feed.pseudosites_ids,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.feed.pseudosites_ids) = $event)),
                          loading: _ctx.pseudositesLoading,
                          options: _ctx.pseudosites.data,
                          "option-value": "id",
                          "option-label": "host"
                        }, null, 8, ["modelValue", "loading", "options"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_FieldText, {
                      modelValue: _ctx.feed.referrer_spoofing_host,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.feed.referrer_spoofing_host) = $event)),
                      modelModifiers: { trim: true },
                      name: "referrer_spoofing_host",
                      "errors-map": _ctx.feedErrorsMap,
                      label: _ctx.$t('referrer_spoofing_host'),
                      help: _ctx.$t('referrer_spoofing_host_help')
                    }, null, 8, ["modelValue", "errors-map", "label", "help"])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.feed.bid_type,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.feed.bid_type) = $event)),
                modelModifiers: { number: true },
                name: "bid_type",
                "errors-map": _ctx.feedErrorsMap,
                label: "Bid scale",
                help: _ctx.$t('bid_type_help'),
                disabled: _ctx.isVideo,
                options: _ctx.BID_TYPES
              }, null, 8, ["modelValue", "errors-map", "help", "disabled", "options"]),
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.feed.bid_subject,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.feed.bid_subject) = $event)),
                modelModifiers: { number: true },
                name: "bid_subject",
                "errors-map": _ctx.feedErrorsMap,
                label: "Bid event",
                disabled: _ctx.isVideo,
                options: _ctx.BID_SUBJECTS
              }, null, 8, ["modelValue", "errors-map", "disabled", "options"]),
              _createVNode(_component_FieldNumber, {
                modelValue: _ctx.feed.revshare,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.feed.revshare) = $event)),
                modelModifiers: { number: true },
                name: "revshare",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('revshare'),
                min: 1,
                max: 200,
                step: 5,
                "show-buttons": "",
                "button-layout": "horizontal",
                "increment-button-icon": "pi pi-plus",
                "decrement-button-icon": "pi pi-minus",
                suffix: "%"
              }, null, 8, ["modelValue", "errors-map", "label"]),
              _createVNode(_component_FieldBidCPM, {
                modelValue: _ctx.feed.fixed_bid,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.feed.fixed_bid) = $event)),
                modelModifiers: { number: true },
                name: "fixed_bid",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('fixed_cpm')
              }, null, 8, ["modelValue", "errors-map", "label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_FieldNumber, {
                modelValue: _ctx.feed.max_clicks_per_ip,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.feed.max_clicks_per_ip) = $event)),
                modelModifiers: { number: true },
                name: "max_clicks_per_ip",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('max_clicks_per_ip'),
                help: _ctx.$t('max_clicks_per_ip_help'),
                min: 0,
                step: 1,
                "show-buttons": "",
                "button-layout": "horizontal",
                "increment-button-icon": "pi pi-plus",
                "decrement-button-icon": "pi pi-minus"
              }, null, 8, ["modelValue", "errors-map", "label", "help"]),
              _createVNode(_component_FieldNumber, {
                modelValue: _ctx.feed.max_revenue_per_day,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.feed.max_revenue_per_day) = $event)),
                modelModifiers: { number: true },
                name: "max_revenue_per_day",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('max_revenue_per_day'),
                help: _ctx.$t('max_revenue_per_day_help'),
                min: 0,
                step: 5,
                "show-buttons": "",
                "button-layout": "horizontal",
                "increment-button-icon": "pi pi-plus",
                "decrement-button-icon": "pi pi-minus",
                prefix: "$"
              }, null, 8, ["modelValue", "errors-map", "label", "help"])
            ])
          ]),
          (_ctx.feed.max_revenue_per_day > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_FieldDropdownNext, {
                    modelValue: _ctx.feed.max_revenue_per_day_strategy,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.feed.max_revenue_per_day_strategy) = $event)),
                    modelModifiers: { number: true },
                    name: "max_revenue_per_day_strategy",
                    "errors-map": _ctx.feedErrorsMap,
                    label: "Delivery method",
                    options: _ctx.FEED_MAX_REVENUE_PER_DAY_STRATEGIES,
                    "option-label-translate": ""
                  }, null, 8, ["modelValue", "errors-map", "options"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("h6", null, "👮 " + _toDisplayString(_ctx.$t('filters')), 1),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_FieldCheckbox, {
                modelValue: _ctx.feed.filter_ip_mismatch,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.feed.filter_ip_mismatch) = $event)),
                label: _ctx.$t('filter_ip_mismatch')
              }, null, 8, ["modelValue", "label"]),
              _createVNode(_component_FieldCheckbox, {
                modelValue: _ctx.feed.filter_proxy,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.feed.filter_proxy) = $event)),
                label: _ctx.$t('filter_proxy')
              }, null, 8, ["modelValue", "label"]),
              _createVNode(_component_FieldCheckbox, {
                modelValue: _ctx.feed.filter_has_no_js,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.feed.filter_has_no_js) = $event)),
                label: _ctx.$t('filter_has_no_js')
              }, null, 8, ["modelValue", "label"]),
              _createVNode(_component_FieldCheckbox, {
                modelValue: _ctx.feed.filter_iframe,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.feed.filter_iframe) = $event)),
                label: _ctx.$t('filter_iframe')
              }, null, 8, ["modelValue", "label"]),
              _createVNode(_component_FieldCheckbox, {
                modelValue: _ctx.feed.filter_headless,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.feed.filter_headless) = $event)),
                label: _ctx.$t('filter_headless')
              }, null, 8, ["modelValue", "label"]),
              _createVNode(_component_FieldCheckbox, {
                modelValue: _ctx.feed.filter_user_agent_mismatch,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.feed.filter_user_agent_mismatch) = $event)),
                label: _ctx.$t('filter_user_agent_mismatch')
              }, null, 8, ["modelValue", "label"]),
              _createVNode(_component_FieldCheckbox, {
                modelValue: _ctx.feed.filter_referrer_mismatch,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.feed.filter_referrer_mismatch) = $event)),
                label: _ctx.$t('filter_referrer_mismatch')
              }, null, 8, ["modelValue", "label"]),
              (!_ctx.isPop)
                ? (_openBlock(), _createBlock(_component_FieldCheckbox, {
                    key: 0,
                    modelValue: _ctx.feed.filter_click_without_impression,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.feed.filter_click_without_impression) = $event)),
                    label: _ctx.$t('filter_click_without_impression')
                  }, null, 8, ["modelValue", "label"]))
                : _createCommentVNode("", true),
              _createVNode(_component_FieldCheckbox, {
                modelValue: _ctx.feed.filter_double_click,
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.feed.filter_double_click) = $event)),
                label: _ctx.$t('filter_double_click')
              }, null, 8, ["modelValue", "label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_FieldNumber, {
                modelValue: _ctx.feed.max_qps,
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.feed.max_qps) = $event)),
                modelModifiers: { number: true },
                name: "max_qps",
                "errors-map": _ctx.feedErrorsMap,
                label: "QPS",
                help: _ctx.$t('max_qps_help'),
                min: 0,
                step: 100,
                "show-buttons": "",
                "button-layout": "horizontal",
                "increment-button-icon": "pi pi-plus",
                "decrement-button-icon": "pi pi-minus"
              }, null, 8, ["modelValue", "errors-map", "help"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.feed.jerk_retries,
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.feed.jerk_retries) = $event)),
                modelModifiers: { number: true },
                name: "jerk_retries",
                "errors-map": _ctx.feedErrorsMap,
                label: "Jerk feed 💦",
                help: "Use for aggressive feed polling to get a non-204 response and secure a higher bid",
                options: _ctx.FEED_JERK_RETRIES
              }, null, 8, ["modelValue", "errors-map", "options"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_FieldDate, {
                modelValue: _ctx.feed.requests_optimization_delay_to,
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.feed.requests_optimization_delay_to) = $event)),
                label: _ctx.$t('requests_optimization_delay_to'),
                "show-time": true
              }, null, 8, ["modelValue", "label"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_FieldCheckbox, {
                modelValue: _ctx.feed.adsecure,
                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.feed.adsecure) = $event)),
                label: "AdSecure"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_FieldCheckbox, {
                modelValue: _ctx.feed.has_violations,
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.feed.has_violations) = $event)),
                label: _ctx.$t('has_violations')
              }, null, 8, ["modelValue", "label"]),
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.feed.status,
                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.feed.status) = $event)),
                modelModifiers: { number: true },
                name: "status",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('status'),
                options: _ctx.FEED_STATUSES
              }, null, 8, ["modelValue", "errors-map", "label", "options"])
            ])
          ]),
          (_ctx.user.isStaff() && !_ctx.user.isLimitedManager())
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_FieldDropdown, {
                    modelValue: _ctx.feed.manager_ids,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.feed.manager_ids) = $event)),
                    name: "manager_ids",
                    "errors-map": _ctx.feedErrorsMap,
                    label: _ctx.$t('manager'),
                    loading: _ctx.managersLoading,
                    "show-clear": true,
                    options: _ctx.managers.data,
                    "option-value": "id",
                    "option-label": "email",
                    "option-label-translate": false,
                    multiple: ""
                  }, null, 8, ["modelValue", "errors-map", "label", "loading", "options"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_FieldTextarea, {
              modelValue: _ctx.feed.comment,
              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.feed.comment) = $event)),
              modelModifiers: { trim: true },
              name: "comment",
              "errors-map": _ctx.feedErrorsMap,
              label: _ctx.$t('comment')
            }, null, 8, ["modelValue", "errors-map", "label"])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.$t('api_token')), 1),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("code", _hoisted_40, _toDisplayString(_ctx.feed.api_token), 1),
              _createVNode(_component_IconPark, {
                class: "cursor-pointer",
                type: "copy",
                theme: "outline",
                size: "11",
                onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.copyToClipboard(_ctx.feed.api_token)))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.feed.api_provider,
                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.feed.api_provider) = $event)),
                modelModifiers: { number: true },
                name: "api_provider",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('feed_api_provider'),
                filter: true,
                "show-clear": true,
                options: _ctx.feedApiProvidersOptions,
                "option-value": "value",
                "option-label": "label",
                "option-label-translate": false
              }, null, 8, ["modelValue", "errors-map", "label", "options"]),
              (_ctx.feed.api_provider)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FEED_API_PROVIDERS_MAP[_ctx.feed.api_provider].fields, (field) => {
                      return (_openBlock(), _createBlock(_resolveDynamicComponent(field.component), {
                        key: field.name,
                        "model-value": _ctx.feed.api_provider_config[field.name],
                        name: `api_provider_config.${field.name}`,
                        "errors-map": _ctx.feedErrorsMap,
                        label: field.label,
                        help: field.help_translate_key ? _ctx.$t(field.help_translate_key) : null,
                        "onUpdate:modelValue": ($event: any) => (_ctx.feed.api_provider_config[field.name] = $event)
                      }, null, 8, ["model-value", "name", "errors-map", "label", "help", "onUpdate:modelValue"]))
                    }), 128)),
                    (_ctx.FEED_API_PROVIDERS_MAP[_ctx.feed.api_provider].help_translate_key)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.$t(_ctx.FEED_API_PROVIDERS_MAP[_ctx.feed.api_provider].help_translate_key)), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.feed.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_FieldText, {
                    "model-value": _ctx.feed.created_at,
                    label: _ctx.$t('created_at'),
                    disabled: ""
                  }, null, 8, ["model-value", "label"]),
                  _createVNode(_component_FieldText, {
                    "model-value": _ctx.feed.updated_at,
                    label: _ctx.$t('updated_at'),
                    disabled: ""
                  }, null, 8, ["model-value", "label"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("h3", _hoisted_46, "🎯 " + _toDisplayString(_ctx.$t('targeting_settings')), 1),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('traffic_category')), 1),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.feed.targeting_by_traffic_category,
                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.feed.targeting_by_traffic_category) = $event)),
                modelModifiers: { number: true },
                name: "targeting_by_traffic_category",
                label: _ctx.$t('targeting_type'),
                options: _ctx.TARGETING_TYPES_BY_TRAFFIC_CATEGORY
              }, null, 8, ["modelValue", "label", "options"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('traffic_source')), 1),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.feed.targeting_by_traffic_source,
                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.feed.targeting_by_traffic_source) = $event)),
                modelModifiers: { number: true },
                name: "targeting_by_traffic_source",
                label: _ctx.$t('targeting_type'),
                options: _ctx.TARGETING_TYPES_BY_TRAFFIC_SOURCE
              }, null, 8, ["modelValue", "label", "options"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('countries')), 1),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.feed.targeting_by_countries,
                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.feed.targeting_by_countries) = $event)),
                modelModifiers: { number: true },
                name: "targeting_by_countries",
                label: _ctx.$t('targeting_type'),
                options: _ctx.TARGETING_TYPES
              }, null, 8, ["modelValue", "label", "options"]),
              (_ctx.feed.targeting_by_countries !== _ctx.TARGETING_TYPE_DISABLED)
                ? (_openBlock(), _createBlock(_component_FieldListBox, {
                    key: 0,
                    modelValue: _ctx.feed.countries_ids,
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.feed.countries_ids) = $event)),
                    loading: _ctx.countriesLoading,
                    options: _ctx.countries.data,
                    "option-value": "id",
                    "option-label": "compiled_name"
                  }, null, 8, ["modelValue", "loading", "options"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('platforms')), 1),
          _createElementVNode("div", _hoisted_58, [
            _createVNode(_component_FieldDropdownNext, {
              modelValue: _ctx.feed.targeting_by_platforms,
              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.feed.targeting_by_platforms) = $event)),
              modelModifiers: { number: true },
              name: "targeting_by_platforms",
              label: _ctx.$t('targeting_type'),
              options: _ctx.TARGETING_TYPES,
              "option-label-translate": ""
            }, null, 8, ["modelValue", "label", "options"]),
            (_ctx.feed.targeting_by_platforms !== _ctx.TARGETING_TYPE_DISABLED)
              ? (_openBlock(), _createBlock(_component_FieldListBox, {
                  key: 0,
                  modelValue: _ctx.feed.platforms_ids,
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.feed.platforms_ids) = $event)),
                  loading: _ctx.platformsLoading,
                  options: _ctx.platforms.data,
                  "option-value": "id",
                  "option-label": "name"
                }, null, 8, ["modelValue", "loading", "options"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('browsers')), 1),
          _createElementVNode("div", _hoisted_60, [
            _createVNode(_component_FieldDropdownNext, {
              modelValue: _ctx.feed.targeting_by_browsers,
              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.feed.targeting_by_browsers) = $event)),
              modelModifiers: { number: true },
              name: "targeting_by_browsers",
              label: _ctx.$t('targeting_type'),
              options: _ctx.TARGETING_TYPES,
              "option-label-translate": ""
            }, null, 8, ["modelValue", "label", "options"]),
            (_ctx.feed.targeting_by_browsers !== _ctx.TARGETING_TYPE_DISABLED)
              ? (_openBlock(), _createBlock(_component_FieldListBox, {
                  key: 0,
                  modelValue: _ctx.feed.browsers_ids,
                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.feed.browsers_ids) = $event)),
                  loading: _ctx.browsersLoading,
                  options: _ctx.browsers.data,
                  "option-value": "id",
                  "option-label": "name"
                }, null, 8, ["modelValue", "loading", "options"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('subids')), 1),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_component_FieldListBox, {
                modelValue: _ctx.feed.quality_presets_ids,
                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.feed.quality_presets_ids) = $event)),
                name: "quality_presets_ids",
                "errors-map": _ctx.feedErrorsMap,
                label: _ctx.$t('quality_presets'),
                loading: _ctx.qualityPresetsLoading,
                options: _ctx.qualityPresets.data,
                "option-value": "id",
                "option-label": "compiled_name"
              }, null, 8, ["modelValue", "errors-map", "label", "loading", "options"]),
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.feed.targeting_by_subids,
                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.feed.targeting_by_subids) = $event)),
                modelModifiers: { number: true },
                name: "targeting_by_subids",
                label: _ctx.$t('targeting_type'),
                options: _ctx.TARGETING_TYPES
              }, null, 8, ["modelValue", "label", "options"]),
              (_ctx.feed.targeting_by_subids !== _ctx.TARGETING_TYPE_DISABLED)
                ? (_openBlock(), _createBlock(_component_TargetingByValues, {
                    key: 0,
                    modelValue: _ctx.feed.subids_uuids,
                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.feed.subids_uuids) = $event)),
                    "allow-uuid": "",
                    label: _ctx.$t('subids_uuids'),
                    help: _ctx.$t('subids_uuids_help')
                  }, null, 8, ["modelValue", "label", "help"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      (_ctx.isPush)
        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t('subscriber_age')), 1),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_component_FieldDropdownNext, {
                    modelValue: _ctx.feed.targeting_by_subscriber_age,
                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.feed.targeting_by_subscriber_age) = $event)),
                    modelModifiers: { number: true },
                    name: "targeting_by_subscriber_age",
                    label: _ctx.$t('targeting_type'),
                    options: _ctx.TARGETING_TYPES_BY_SUBSCRIBER_AGE,
                    "option-label-translate": ""
                  }, null, 8, ["modelValue", "label", "options"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.$t('endpoints')), 1),
            _createElementVNode("div", _hoisted_71, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.feed.targeting_by_endpoints_ids,
                "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.feed.targeting_by_endpoints_ids) = $event)),
                modelModifiers: { number: true },
                name: "targeting_by_endpoints_ids",
                label: _ctx.$t('targeting_type'),
                options: _ctx.TARGETING_TYPES,
                "option-label-translate": ""
              }, null, 8, ["modelValue", "label", "options"]),
              (_ctx.feed.targeting_by_endpoints_ids !== _ctx.TARGETING_TYPE_DISABLED)
                ? (_openBlock(), _createBlock(_component_FieldListBox, {
                    key: 0,
                    modelValue: _ctx.feed.endpoints_ids,
                    "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.feed.endpoints_ids) = $event)),
                    name: "endpoints_ids",
                    "errors-map": _ctx.feedErrorsMap,
                    label: _ctx.$t('endpoints'),
                    loading: _ctx.endpointsLoading,
                    options: _ctx.endpoints.data,
                    "option-value": "id",
                    "option-label": "compiled_name"
                  }, null, 8, ["modelValue", "errors-map", "label", "loading", "options"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      (!!_ctx.feed.id)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[85] || (_cache[85] = _createElementVNode("h3", null, "Miscellaneous ℹ️", -1)),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                (_openBlock(), _createBlock(_Suspense, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_AdSecure, {
                      filters: { feed_id: _ctx.feed.id },
                      "show-relations-columns": false
                    }, null, 8, ["filters"])
                  ]),
                  fallback: _withCtx(() => [
                    _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                  ]),
                  _: 1
                }))
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["entry-errors-map", "title", "entry", "entry-fetch-handler", "entry-store-handler"]))
}